import { Action, ModalState } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';

const initialState: ModalState = {
	isModalOpen: false,
	children: null,
};

const modalReducer = (state = initialState, action: Action) => {
	switch (action.type) {
		case actionTypes.MODAL_OPEN:
			return {
				...state,
				isModalOpen: action.payload.isModalOpen,
			};
		case actionTypes.MODAL_CLOSE:
			return {
				...state,
				isModalOpen: action.payload.isModalOpen,
			};
		case actionTypes.SET_MODAL_CONTENT:
			return {
				...state,
				children: action.payload.children,
				settings: action.payload.settings,
			};
		default:
			return state;
	}
};

export default modalReducer;
